export const environment = {
  production: true,
  debugMode: true,
  ENVIRONMENT: 'dev',
  registerServiceWorker: true,
  sentryDSN: 'https://a40e8719561d497aa04f7fbec1489d21@errcol.g.placewise.com/4',
  sentryEnvironment: 'dev',
  commitId: '8220cdb3036316cd65840be253013f3f57770afe',
  webforms_api: '/api',
  passwordMinLength: 8,
  dmpEvents: true,
  recaptchaBaseKey: '6LcVLSwdAAAAAFdAdLYMetuwSOz_qnQZ8_wTJGM_',
  recaptchaCheckboxKey: '6LfGyzcdAAAAAOSE24RnK9P4bzGjyEadx3RLJ6Bd',
  authApi: '/v1',
  mobileEventsDebugEnabled: false,
};
